import React from 'react';
import { ProjectId } from '../../../models/Types';
import { makePrioStyles } from '../../../theme/utils';
import Flex from '../../../components/Flex';
import { useTheme } from 'react-jss';
import { PrioTheme } from '../../../theme/types';
import ProjectMailAssignmentSetting from './ProjectMailAssignmentSetting';
import AbsenceAutoReplySetting from './AbsenceAutoReplySetting';
import ProjectMailAutoMarkAsReadSetting from './ProjectMailAutoMarkAsReadSetting';
import { ESettingScope } from '../../../models/Settings';
import SingleStringSettingManagement from './SingleStringSettingManagement';
import { useTranslation } from 'react-i18next';

const useStyles = makePrioStyles((theme) => ({
  root: {
    backgroundColor: theme.old.palette.backgroundPalette.sub,
    padding: theme.old.spacing.defaultPadding,
    height: '100%',
    overflowY: 'auto',
  },
  shadow: {
    boxShadow: theme.old.palette.boxShadow.regular,
  },
}));

interface MailSettingsPageProps {
  projectId: ProjectId;
}

export const MailSettingsPage: React.FC<MailSettingsPageProps> = (props) => {
  const classes = useStyles();
  const theme = useTheme<PrioTheme>();
  const { t } = useTranslation();
  const { projectId } = props;

  return (
    <div className={classes.root}>
      <Flex.Column childrenGap={theme.old.spacing.unit(2)}>
        <ProjectMailAssignmentSetting
          className={classes.shadow}
          projectId={projectId}
        />
        <SingleStringSettingManagement
          className={classes.shadow}
          projectId={projectId}
          settingKey="SharedMailbox_Subject"
          settingType="emailSubject"
          title={t(
            'projects:projectMailSettingsManagement.labels.emailSubject'
          )}
          addNewLabel={t(
            'projects:projectMailSettingsDropdownManagement.addNewSubject'
          )}
          newValuePlaceholder={t(
            'projects:projectMailSettingsDropdownManagement.newSubjectPlaceholder'
          )}
        />
        <SingleStringSettingManagement
          className={classes.shadow}
          projectId={projectId}
          settingKey="SharedMailbox_Signature"
          settingType="emailSignature"
          title={t(
            'projects:projectMailSettingsManagement.labels.emailSignature'
          )}
          addNewLabel={t(
            'projects:projectMailSettingsDropdownManagement.addNewSignature'
          )}
          newValuePlaceholder={t(
            'projects:projectMailSettingsDropdownManagement.newSignaturePlaceholder'
          )}
          previewType="html"
          inputType="html-editor"
        />
        <AbsenceAutoReplySetting
          className={classes.shadow}
          projectId={projectId}
          scope={ESettingScope.PROJECT}
        />
        <ProjectMailAutoMarkAsReadSetting
          className={classes.shadow}
          projectId={projectId}
        />
      </Flex.Column>
    </div>
  );
};

export default MailSettingsPage;
